export interface Logger {
  warning(message: string, data: Record<string, any>, strategy?: string): void;
  error(error: any, message: string, strategy?: string): void;
  debug(message: string, data: Record<string, any>, strategy?: string): void;
  info(message: string, data: Record<string, any>, strategy?: string): void;
}



export enum LoggerStrategies {
  serverLogger = 'serverLogger',
  instanaLogger = 'instanaLogger'
}
